/**
 * 108 TYM site behaviours for the redesigned sections.
 * - Collection sort: applies the chosen sort as soon as the select changes.
 * - Scroll reveal for elements marked [data-lux-reveal] (skipped in the theme editor
 *   and for reduced motion; content stays visible if this script never runs).
 */

// Sort select: delegated so it also works after sections re-render.
document.addEventListener('change', (event) => {
  const select = event.target;
  if (!(select instanceof HTMLSelectElement) || !select.matches('[data-lux-sort]')) return;

  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', select.value);
  url.searchParams.delete('page');
  window.location.assign(url.toString());
});

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!window.Shopify?.designMode && !reduceMotion && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  /**
   * Only elements that start below the viewport are hidden, so nothing already on
   * screen flickers when this module loads.
   * @param {ParentNode} root
   */
  const observe = (root) => {
    for (const element of root.querySelectorAll('[data-lux-reveal]:not(.is-revealed, .lux-reveal-pending)')) {
      if (element.getBoundingClientRect().top < window.innerHeight) continue;
      element.classList.add('lux-reveal-pending');
      observer.observe(element);
    }
  };

  observe(document);

  // Sections added later (theme editor is excluded above; this covers AJAX section loads).
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) if (node instanceof Element) observe(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
}
